import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import AuthLogin from "./app/authentication/login";
import MatxLayout from "./app/component/maxLayout";
import NotFound from "./app/layout/sessions/NotFound";
import { DashboardTable } from "./app/component/userTable/userListTable";
import Race from "./app/component/race/race";
import WorldWide from "./app/component/highScore/worldWide";
import { Standing } from "./app/component/standing/standing";
import { Seasons } from "./app/component/seasons/seasons";
import { SeasonsList } from "./app/component/seasons/seasonsList";
import RaceExcelUpload from "./app/component/race/raceExcelUpload"; 
import { SingleUserTable } from "./app/component/userTable/userPredictionList";
import { StandingPerUer } from "./app/component/standing/standingPerUser";
import CountryLists from "./app/component/countryList/countryList";
import Feedback from "./app/component/feedBack/feedback";
import { ColorCode } from "./app/component/colorCode/colorCode";
import { SingleColorCode } from "./app/component/colorCode/singleColor";
import Setting from "./app/component/setting/setting";
import CountryCode from "./app/component/countryCode/countryCode";
import Notification from "./app/component/notifications/notification";
import SouthAmerica from "./app/component/highScore/south_america";
import Asia from "./app/component/highScore/asia";
import Antarctica from "./app/component/highScore/antarctica";
import Oceania from "./app/component/highScore/oceania";
import NorthAmerica from "./app/component/highScore/north_america";
import Africa from "./app/component/highScore/africa";
import Europe from "./app/component/highScore/europe";
import Groups from "./app/component/groups/groups";
import { GroupDetails } from "./app/component/groups/groupdetails";

function RedirectionWrapper({ to }) {
  const queryString = window.location.search;
  if (queryString) {
    return <Navigate to={`${to}${queryString}`} />;
  }
  return <Navigate to={to} />;
}

const routes = (isLoggedIn) => [
  {
    path: "/",
    element: isLoggedIn ? <MatxLayout /> : <RedirectionWrapper to="/login" />,
    children: [
      {
        index: true,
        element: <RedirectionWrapper to="/race" />,
      },
      {
        path: "/user/",
        element: <DashboardTable />,
      },
      {
        path: "/race/",
        element: <Race />,
      },
      {
        path: "/standing/",
        element: <Standing />,
      },
      {
        path: "/seasons/",
        element: <Seasons />,
      },
      {
        path: "/seasonlist/",
        element: <SeasonsList />,
      },
      {
        path: "/groups/",
        element: <Groups />,
      },
      {
        path: "/groups/groupdetails/",
        element: <GroupDetails />,
      },
      {
        path: "/raceexcelupload/",
        element: <RaceExcelUpload />,
      },
      {
        path: "/userprediction/",
        element: <SingleUserTable />,
      },
      {
        path: "/standinguser/",
        element: <StandingPerUer />,
      },
      {
        path: "/highscore/",
        element: <WorldWide />,
      },
      {
        path: "/highscore/southAmerica/",
        element: <SouthAmerica />,
      },
      {
        path: "/highscore/asia/",
        element: <Asia />,
      },
      {
        path: "/highscore/oceania/",
        element: <Oceania />,
      },
      {
        path: "/highscore/northAmerica/",
        element: <NorthAmerica />,
      },
      {
        path: "highscore/europe/",
        element: <Europe />,
      },
      {
        path: "/highscore/africa/",
        element: <Africa />,
      },
      {
        path: "/highscore/middleEast/",
        element: <Antarctica />,
      },
      {
        path: "/countrylist/",
        element: <CountryLists />,
      },
      {
        path: "/feedback/",
        element: <Feedback />,
      },
      {
        path: "/setting/",
        element: <Setting />,
      },
      {
        path: "/colorcode/",
        element: <ColorCode />,
      },
      {
        path: "/colorcode/:id",
        element: <SingleColorCode />,
      },
      {
        path: "/countrycode",
        element: <CountryCode />,
      },
      {
        path: "/notification",
        element: <Notification />,
      },
    ],
  },
  {
    path: "/login",
    element: !isLoggedIn ? <AuthLogin /> : <RedirectionWrapper to="/race?type=f1" />,
  },
  { path: "*", element: <NotFound /> },
];

export default function Routes(props) {
  const { isLoggedIn } = props;
  return useRoutes(routes(isLoggedIn));
}
